import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FinancialPageComponent } from './components/financial-page/financial-page.component';
import { AdminFinancialComponent } from './components/admin-financial/admin-financial.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path: ':name', component: FinancialPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard],  component: AdminFinancialComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FinancialRoutingModule { }
